import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/canteenDailyReport/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/canteenDailyReport/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/canteenDailyReport/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/canteenDailyReport/submit', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/canteenDailyReport/submit', params, options);
export const submitUploadBill = (formData) => {
  return request({
    url: '/api/v4ward/canteenDailyReport/upload',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};
